import {Action} from "redux";
import {
    UpdateCustomerByCustomerRequest,
    UpdatePasswordByCustomerRequest,
    UpdateEmailByCustomerRequest, GenerateCustomerPDFByCustomerRequest, DestroyCustomerPDFByCustomerRequest,
} from "../request/mypage_request";

import {
    GetMeCustomerByCustomerResponse,
    UpdateCustomerByCustomerResponse,
    UpdatePasswordByCustomerResponse,
    UpdateEmailByCustomerResponse, GenerateCustomerPDFByCustomerResponse, DestroyCustomerPDFByCustomerResponse,
} from "../response/mypage_response";

export enum CustomerMypageActionType {
    REQUEST_GET_ME_CUSTOMER = "CUSTOMER_MYPAGE_REQUEST_GET_ME_CUSTOMER",
    CALLBACK_GET_ME_CUSTOMER = "CUSTOMER_MYPAGE_CALLBACK_GET_ME_CUSTOMER",

    REQUEST_UPDATE_CUSTOMER = "CUSTOMER_MYPAGE_REQUEST_UPDATE_CUSTOMER",
    CALLBACK_UPDATE_CUSTOMER = "CUSTOMER_MYPAGE_CALLBACK_UPDATE_CUSTOMER",

    REQUEST_UPDATE_PASSWORD = "CUSTOMER_MYPAGE_REQUEST_UPDATE_PASSWORD",
    CALLBACK_UPDATE_PASSWORD = "CUSTOMER_MYPAGE_CALLBACK_UPDATE_PASSWORD",

    REQUEST_UPDATE_EMAIL = "CUSTOMER_MYPAGE_REQUEST_UPDATE_EMAIL",
    CALLBACK_UPDATE_EMAIL = "CUSTOMER_MYPAGE_CALLBACK_UPDATE_EMAIL",

    REQUEST_GENERATE_CUSTOMER_PDF = "CUSTOMER_MYPAGE_REQUEST_GENERATE_CUSTOMER_PDF",
    CALLBACK_GENERATE_CUSTOMER_PDF = "CUSTOMER_MYPAGE_CALLBACK_GENERATE_CUSTOMER_PDF",

    REQUEST_DESTROY_CUSTOMER_PDF = "CUSTOMER_MYPAGE_REQUEST_DESTROY_CUSTOMER_PDF",
    CALLBACK_DESTROY_CUSTOMER_PDF = "CUSTOMER_MYPAGE_CALLBACK_DESTROY_CUSTOMER_PDF",
}

export interface IRequestGetMeCustomerAction extends Action {
    type: CustomerMypageActionType.REQUEST_GET_ME_CUSTOMER;
}
export interface ICallbackGetMeCustomerAction extends Action {
    type: CustomerMypageActionType.CALLBACK_GET_ME_CUSTOMER;
    isSuccess: boolean;
    item?: GetMeCustomerByCustomerResponse;
}

export interface IRequestUpdateCustomerAction extends Action {
    type: CustomerMypageActionType.REQUEST_UPDATE_CUSTOMER;
    item: UpdateCustomerByCustomerRequest,
}
export interface ICallbackUpdateCustomerAction extends Action {
    type: CustomerMypageActionType.CALLBACK_UPDATE_CUSTOMER;
    isSuccess: boolean;
    item?: UpdateCustomerByCustomerResponse;
}

export interface IRequestUpdatePasswordAction extends Action {
    type: CustomerMypageActionType.REQUEST_UPDATE_PASSWORD;
    item: UpdatePasswordByCustomerRequest;
}
export interface ICallbackUpdatePasswordAction extends Action {
    type: CustomerMypageActionType.CALLBACK_UPDATE_PASSWORD;
    isSuccess: boolean;
    item: UpdatePasswordByCustomerResponse;
}

export interface IRequestUpdateEmailAction extends Action {
    type: CustomerMypageActionType.REQUEST_UPDATE_EMAIL;
    item: UpdateEmailByCustomerRequest;
}
export interface ICallbackUpdateEmailAction extends Action {
    type: CustomerMypageActionType.CALLBACK_UPDATE_EMAIL;
    isSuccess: boolean;
    item: UpdateEmailByCustomerResponse;
}

export interface IRequestGenerateCustomerPDFAction extends Action {
    type: CustomerMypageActionType.REQUEST_GENERATE_CUSTOMER_PDF;
    item: GenerateCustomerPDFByCustomerRequest;
}
export interface ICallbackGenerateCustomerPDFAction extends Action {
    type: CustomerMypageActionType.CALLBACK_GENERATE_CUSTOMER_PDF;
    isSuccess: boolean;
    item: GenerateCustomerPDFByCustomerResponse;
}

export interface IRequestDestroyCustomerPDFAction extends Action {
    type: CustomerMypageActionType.REQUEST_DESTROY_CUSTOMER_PDF;
    item: DestroyCustomerPDFByCustomerRequest;
}
export interface ICallbackDestroyCustomerPDFAction extends Action {
    type: CustomerMypageActionType.CALLBACK_DESTROY_CUSTOMER_PDF;
    isSuccess: boolean;
    item: DestroyCustomerPDFByCustomerResponse;
}

export type CustomerMypageAction =
    IRequestGetMeCustomerAction |
    ICallbackGetMeCustomerAction |
    IRequestUpdateCustomerAction |
    ICallbackUpdateCustomerAction |
    IRequestUpdatePasswordAction |
    ICallbackUpdatePasswordAction |
    IRequestUpdateEmailAction |
    ICallbackUpdateEmailAction |
    IRequestGenerateCustomerPDFAction |
    ICallbackGenerateCustomerPDFAction |
    IRequestDestroyCustomerPDFAction |
    ICallbackDestroyCustomerPDFAction
    ;

export interface ICustomerMypageActionCreator {
    requestGetMeCustomerAction(
    ): IRequestGetMeCustomerAction;
    callbackGetMeCustomerAction(
        isSuccess: boolean,
        item?: GetMeCustomerByCustomerResponse,
    ): ICallbackGetMeCustomerAction;

    requestUpdateCustomerAction(
        item: UpdateCustomerByCustomerRequest,
    ): IRequestUpdateCustomerAction;
    callbackUpdateCustomerAction(
        isSuccess: boolean,
        item?: UpdateCustomerByCustomerResponse,
    ): ICallbackUpdateCustomerAction;

    requestUpdatePasswordAction(
        item: UpdatePasswordByCustomerRequest,
    ): IRequestUpdatePasswordAction;
    callbackUpdatePasswordAction(
        isSuccess: boolean,
        item?: UpdatePasswordByCustomerResponse
    ): ICallbackUpdatePasswordAction;

    requestUpdateEmailAction(
        item: UpdateEmailByCustomerRequest,
    ): IRequestUpdateEmailAction;
    callbackUpdateEmailAction(
        isSuccess: boolean,
        item?: UpdateEmailByCustomerResponse
    ): ICallbackUpdateEmailAction;

    requestGenerateCustomerPDFAction(
        item: GenerateCustomerPDFByCustomerRequest,
    ): IRequestGenerateCustomerPDFAction;
    callbackGenerateCustomerPDFAction(
        isSuccess: boolean,
        item?: GenerateCustomerPDFByCustomerResponse
    ): ICallbackGenerateCustomerPDFAction;

    requestDestroyCustomerPDFAction(
        item: DestroyCustomerPDFByCustomerRequest,
    ): IRequestDestroyCustomerPDFAction;
    callbackDestroyCustomerPDFAction(
        isSuccess: boolean,
        item?: DestroyCustomerPDFByCustomerResponse
    ): ICallbackDestroyCustomerPDFAction;
}

class ActionCreator implements ICustomerMypageActionCreator {
    public requestGetMeCustomerAction = (
    ): IRequestGetMeCustomerAction => {
        return {
            type: CustomerMypageActionType.REQUEST_GET_ME_CUSTOMER,
        };
    };
    public callbackGetMeCustomerAction = (
        isSuccess: boolean,
        item?: GetMeCustomerByCustomerResponse,
    ): ICallbackGetMeCustomerAction => {
        return {
            type: CustomerMypageActionType.CALLBACK_GET_ME_CUSTOMER,
            isSuccess,
            item,
        };
    };

    public requestUpdateCustomerAction = (
        item: UpdateCustomerByCustomerRequest,
    ): IRequestUpdateCustomerAction => {
        return {
            type: CustomerMypageActionType.REQUEST_UPDATE_CUSTOMER,
            item,
        };
    };
    public callbackUpdateCustomerAction = (
        isSuccess: boolean,
        item?: UpdateCustomerByCustomerResponse,
    ): ICallbackUpdateCustomerAction => {
        return {
            type: CustomerMypageActionType.CALLBACK_UPDATE_CUSTOMER,
            isSuccess,
            item,
        };
    };

    public requestUpdatePasswordAction = (
        item: UpdatePasswordByCustomerRequest,
    ): IRequestUpdatePasswordAction => {
        return {
            type: CustomerMypageActionType.REQUEST_UPDATE_PASSWORD,
            item,
        };
    };
    public callbackUpdatePasswordAction = (
        isSuccess: boolean,
        item: UpdatePasswordByCustomerResponse,
    ): ICallbackUpdatePasswordAction => {
        return {
            type: CustomerMypageActionType.CALLBACK_UPDATE_PASSWORD,
            isSuccess,
            item,
        };
    };

    public requestUpdateEmailAction = (
        item: UpdateEmailByCustomerRequest,
    ): IRequestUpdateEmailAction => {
        return {
            type: CustomerMypageActionType.REQUEST_UPDATE_EMAIL,
            item,
        };
    };
    public callbackUpdateEmailAction = (
        isSuccess: boolean,
        item: UpdatePasswordByCustomerResponse,
    ): ICallbackUpdateEmailAction => {
        return {
            type: CustomerMypageActionType.CALLBACK_UPDATE_EMAIL,
            isSuccess,
            item,
        };
    };

    public requestGenerateCustomerPDFAction = (
        item: GenerateCustomerPDFByCustomerRequest,
    ): IRequestGenerateCustomerPDFAction => {
        return {
            type: CustomerMypageActionType.REQUEST_GENERATE_CUSTOMER_PDF,
            item,
        };
    };
    public callbackGenerateCustomerPDFAction = (
        isSuccess: boolean,
        item: GenerateCustomerPDFByCustomerResponse,
    ): ICallbackGenerateCustomerPDFAction => {
        return {
            type: CustomerMypageActionType.CALLBACK_GENERATE_CUSTOMER_PDF,
            isSuccess,
            item,
        };
    };

    public requestDestroyCustomerPDFAction = (
        item: DestroyCustomerPDFByCustomerRequest,
    ): IRequestDestroyCustomerPDFAction => {
        return {
            type: CustomerMypageActionType.REQUEST_DESTROY_CUSTOMER_PDF,
            item,
        };
    };
    public callbackDestroyCustomerPDFAction = (
        isSuccess: boolean,
        item: DestroyCustomerPDFByCustomerResponse,
    ): ICallbackDestroyCustomerPDFAction => {
        return {
            type: CustomerMypageActionType.CALLBACK_DESTROY_CUSTOMER_PDF,
            isSuccess,
            item,
        };
    };

}

export const createCustomerMypageActionCreator = (): ICustomerMypageActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_mypage_action.ts